import React, { useMemo } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import classNames from 'classnames';
import {
  Typography,
	CircularProgress
} from '@material-ui/core';
import TransactionEventHistoryGrid from 'components/underwrite/shared/histories/TransactionEventHistoryGrid';
import { LoadingOverlayWrapper } from 'components/layout';
import { setPostAcqSelectedTaskHistoryTab } from 'store/actions';
import PostAcqUWTaskHistoryGrid from 'components/underwrite/postAcquisition/postAcqUnderwrite/histories/PostAcqUWTaskHistoryGrid';

const PostAcqHistoryTabs = ({ classes, transactionEvents, tasks, taskId, isFetchingTransactionEvents,
	isFetchingTaskHistory, selectedTaskHistoryTab, setPostAcqSelectedTaskHistoryTab }) => {

	const tasksTitle = `Task History${tasks ? ` (${tasks.length})` : ''}`;
	const transactionEventsTitle = `Transaction History${transactionEvents ? ` (${transactionEvents.length})` : ''}`;
  return (
		<div>
			<div className={classes.tabContainer}>
				<div className={classNames(classes.tab, selectedTaskHistoryTab === 'tasks' && classes.selectedTab)} style={{ display: 'flex' }} onClick={() => setPostAcqSelectedTaskHistoryTab('tasks')}>
					<Typography className={classes.title} variant="subtitle2">{tasksTitle}</Typography>
					{isFetchingTaskHistory &&
						<CircularProgress size={16} style={{ marginLeft: 8 }}/>
					}
				</div>
				<div className={classNames(classes.tab, selectedTaskHistoryTab === 'transactionEvents' && classes.selectedTab)} onClick={() => setPostAcqSelectedTaskHistoryTab('transactionEvents')}>
					<Typography className={classes.title} variant="subtitle2">{transactionEventsTitle}</Typography>
					{isFetchingTransactionEvents &&
						<CircularProgress size={16} style={{ marginLeft: 8 }}/>
					}
				</div>
			</div>
			<div style={{ 
				// height: 204,
				margin: '0 8px 8px' }}>
				{
					selectedTaskHistoryTab === 'tasks'
						? <LoadingOverlayWrapper
								active={isFetchingTaskHistory}
								message={'Fetching history...'}
								style={{ height: '100%' }}
							>
								<PostAcqUWTaskHistoryGrid tasks={tasks} taskId={taskId} />
							</LoadingOverlayWrapper>
						: <LoadingOverlayWrapper
								active={isFetchingTransactionEvents}
								message={'Fetching transaction events...'}
								style={{ height: '100%' }}
							>
								<TransactionEventHistoryGrid gudTransactionEvents={transactionEvents} />
							</LoadingOverlayWrapper>
				}
			</div>
		</div>
  )
};

const styles = theme => ({
	tabContainer: {
		display: 'flex',
		marginLeft: 8,
		// marginBottom: 6
	},
	tab: {
		border: '1px solid #e0e0e0',
		borderBottom: 0,
		borderRadius: '8px 8px 0 0',
		padding: '2px 8px',
		cursor: 'pointer',
		display: 'flex',
		alignItems: 'center'
	},
	selectedTab: {
		backgroundColor: '#e1f2fb'
	},
  title: {
    // marginBottom: 6,
    // marginLeft: 8
  },
	warningIcon: {
		marginLeft: 6
	},
  noBidReason: {
    color: theme.palette.warning.text,
    fontWeight: 'bold'
  },
  doNotBuyWarning: {
    color: theme.palette.red.dark,
    fontWeight: 'bold'
  },
  highFidelityFieldsWarning: {
    color: "#5baeff",
    fontWeight: 'bold'
  }
})

const mapStateToProps = (state) => {
	return {
		isFetchingTransactionEvents: state.postAcqUWState.isFetchingTransactionEvents, 
		isFetchingTaskHistory: state.postAcqUWState.isFetchingTaskHistory,
		selectedTaskHistoryTab: state.postAcqUWState.selectedTaskHistoryTab
	}
};

const mapDispatchToProps = {
	setPostAcqSelectedTaskHistoryTab
}

export default compose(
	withStyles(styles),
	connect(mapStateToProps, mapDispatchToProps)
)(PostAcqHistoryTabs);
